export const USERS = 'admin/users/all'
export const USER = 'admin/users/edit'
export const CREATE_USER = 'admin/users/add'
export const UPDATE_USER = 'admin/users/update'
export const DELETE_USER = 'admin/users/delete'
